import { render } from "./SelectOptionBox.vue?vue&type=template&id=12cc4fbd&scoped=true"
import script from "./SelectOptionBox.vue?vue&type=script&lang=js"
export * from "./SelectOptionBox.vue?vue&type=script&lang=js"

import "./SelectOptionBox.vue?vue&type=style&index=0&id=12cc4fbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cc4fbd"]])

export default __exports__